import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Form } from 'components/shared/Form/Form'

import { ASSESSMENT_GROUP_FIELD, SCORE_FIELD, SKILL_RANGE } from '../../model'

import styles from './AssessmentForm.module.scss'

export const AssessmentForm = ({
  className = undefined,
  control,
  index,
  watch,
}) => {
  const score = watch(`${ASSESSMENT_GROUP_FIELD}[${index}].${SCORE_FIELD}`)

  return (
    <Form className={cx(styles.assessment, className)}>
      <span className={styles.scoreTitle}>{t`Overall score`}</span>
      <Box align="center" className={styles.score} justify="center">
        {Array.from({ length: SKILL_RANGE }, (_, index) => index + 1).map(
          value => (
            <Form.Field
              className={styles.field}
              id={`score-${value}`}
              field="score"
              key={value}
              label={value}
              labelSize="medium"
              name={`${ASSESSMENT_GROUP_FIELD}[${index}].${SCORE_FIELD}`}
              score={value}
              isScoreActive={Number(score) === value}
              {...{ control }}
            />
          ),
        )}
      </Box>
      {/*<Form.Field
        field="textarea"
        fieldClassName={styles.textarea}
        label={t`Notes`}
        name={`${ASSESSMENT_GROUP_FIELD}[${index}].${COMMENT_FIELD}`}
        isOptional
        {...{ control }}
      />*/}
    </Form>
  )
}
